import 'glightbox/dist/css/glightbox.min.css'
import GLightbox from 'glightbox'

const glighboxVideoBtnsSelectors = [
  '.hero__video-btn',
  '.video-block__overlay',
  '.solving-video__btn'
]
glighboxVideoBtnsSelectors.forEach(selector => {
  GLightbox({
    selector,
    autoplayVideos: true
  })
})